import { memo } from "react"
import SummaryContainerStyled from "components/Summary/Summary.styled"
import { IMenu } from "interfaces/IMenu"
import CardOption from "components/Summary/SummaryOption/CardOption"
import { GridContainer, FlexContainer } from "theme/common/Grid.styled"

const SummaryOptions = memo(({ summaryOptions, contractor = false, grid = true }: { summaryOptions: IMenu[], contractor?: boolean, grid?: boolean }) => {

  return (
    <SummaryContainerStyled>
      <p className="title-summary"><b>{contractor ? "Selecciona una bandeja" : "Resumen de actividades"}</b></p>
      {grid ? (
        <GridContainer minSize="320px">
          {summaryOptions.map(({ icon, optionCount, path, title, stateLocation }, index) => (
            <CardOption
              index={index}
              key={`${path}-${title}`}
              icon={icon}
              optionCount={optionCount}
              path={path}
              title={title}
              stateLocation={stateLocation}
            />
          ))}
        </GridContainer>
      ) : (
        <FlexContainer>
          {summaryOptions.map(({ icon, optionCount, path, title, stateLocation }, index) => (
            <CardOption
              index={index}
              key={`${path}-${title}`}
              icon={icon}
              optionCount={optionCount}
              path={path}
              title={title}
              stateLocation={stateLocation}
            />
          ))}
        </FlexContainer>
      )}
    </SummaryContainerStyled>
  )
})

export default SummaryOptions
